module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-8.82768be4.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-8.png
// module id = 198
// module chunks = 0